import React, { useCallback } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { InputSelect } from '@daedalus/atlas/InputSelect';
import { getLinariaClassName } from '@daedalus/atlas/utils/getLinariaClassName';
export type AgeFieldSize = (typeof AGE_FIELD_SIZES)[number];
interface Props {
  displayName?: string;
  onChange: (value: number) => void;
  value: number;
  size?: AgeFieldSize;
}
interface AgeListItemProps {
  label: string;
  value: number;
}
const MAX_CHILD_AGE = 18;
const InputLabelText = /*#__PURE__*/styled('div')({
  name: "InputLabelText",
  class: "i1k3e7tf",
  propsAsIs: false
});
const InputWrapper = /*#__PURE__*/styled('div')({
  name: "InputWrapper",
  class: "i1ikoo1v",
  propsAsIs: false
});
const getAgeList = (): AgeListItemProps[] => {
  const ageList = [{
    label: '<1',
    value: 0
  }];
  for (let i = 1; i < MAX_CHILD_AGE; i++) {
    ageList.push({
      label: i.toString(),
      value: i
    });
  }
  return ageList;
};
export const AgeField = ({
  displayName,
  onChange,
  value,
  size = 'lg'
}: Props) => {
  const handleChange = useCallback((value: string) => {
    onChange(Number(value));
  }, [onChange]);
  const ageList = getAgeList();
  return <Grid container alignItems="center">
      <Grid mobileSm="fill">
        <InputLabelText>{displayName}</InputLabelText>
      </Grid>
      <Grid mobileSm="fit">
        <InputWrapper className={cx(`${getLinariaClassName(InputWrapper)}--size-${size}`)}>
          <InputSelect value={value.toString()} size={size} onChange={handleChange}>
            {ageList.map((age: AgeListItemProps) => <option key={age.value} value={age.value}>
                {age.label}
              </option>)}
          </InputSelect>
        </InputWrapper>
      </Grid>
    </Grid>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");